import { AccessRule, FlagAccess, FlagRule, NavAccess } from './types';

/** Joker feature key: when enabled it grants access to every gated item. */
export const ALL_FEATURES = 'all_features';

/** Normalize the `flag` gate (single/array, string/rule) to a list of rules. */
export const toFlagRules = (flag: FlagAccess | FlagAccess[]): FlagRule[] =>
    (Array.isArray(flag) ? flag : [flag]).map((entry) => (typeof entry === 'string' ? { key: entry } : entry));

/**
 * The single access predicate. Three consumers read it: the sidebar
 * (via `resolveNavItems`), route guards (via `canAccessRoute`), and active-page
 * enforcement (`useEnforceAccess`). Pure — no store/hook access.
 */
export const canAccess = (access: AccessRule, navAccess: NavAccess): boolean => {
    // The flag gate is always enforced — even the joker must satisfy it.
    if (access.flag) {
        const passes = toFlagRules(access.flag).some((rule) => {
            const value = navAccess.flags[rule.key];

            return rule.predicate ? rule.predicate(value) : Boolean(value);
        });

        if (!passes) {
            return false;
        }
    }

    // The joker unlocks the remaining gates (account/feature) once flags pass.
    if (navAccess.features[ALL_FEATURES]) {
        return true;
    }

    if (access.account === 'paid' && !navAccess.isPaid) {
        return false;
    }

    if (access.feature) {
        const keys = Array.isArray(access.feature) ? access.feature : [access.feature];

        if (!keys.some((key) => navAccess.features[key])) {
            return false;
        }
    }

    return true;
};
